import {
  SolarLeaderBoardSiteDuplicateCheck,
  DuplicateSite,
} from '@black-bear-energy/black-bear-energy-common'
import { DromoSiteRecord, SiteAction } from 'common/types'
import { AxiosInstance } from 'axios'
import { parseDuplicateCheckResults } from '../DromoUploader/parseDuplicateCheckResults'

export async function checkForDuplicates(
  sites: DromoSiteRecord[],
  reitId: number,
  api: AxiosInstance
) {
  const dupeCheckSites: SolarLeaderBoardSiteDuplicateCheck[] = sites
    .filter((site) => site.siteAction !== SiteAction.Ignore)
    .map((site) => getSiteDuplicateCheck(site))

  const dupeCheckResponse = await api.post<DuplicateSite[]>(
    '/solar-leaderboard-sites/dedupe',
    {
      reitId,
      sites: dupeCheckSites,
    }
  )

  return parseDuplicateCheckResults(dupeCheckResponse.data, sites)
}

function getSiteDuplicateCheck(
  site: DromoSiteRecord
): SolarLeaderBoardSiteDuplicateCheck {
  const siteAction = site.siteAction
  const existingSiteToModify = [SiteAction.Update, SiteAction.Sold].includes(
    siteAction
  )
    ? parseInt(site.existingRecordId as string)
    : undefined
  return {
    id: site.rowId as string,
    name: site.name as string,
    latitude: site.latitude as number,
    longitude: site.longitude as number,
    systemSize: site.systemSize as number,
    existingSiteToModify,
  } satisfies SolarLeaderBoardSiteDuplicateCheck
}
